import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import router from "@/router";
import { EventBus } from "@/plugins/eventBus";
const baseUrl = "base/api/v1/";

const parsinaSupportXios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});
parsinaSupportXios.headers = { "Accept-language": "en-US" };
parsinaSupportXios.defaults.headers.common["Content-Type"] = "application/json";
parsinaSupportXios.defaults.headers.common["Authorization"] =
  localStorage.mitaParsinaSupportToken;

export default {
  // Members Authentications -------------------------------------------------------
  login({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "parsina/ParsinaAccount", data)
      .then((res) => {
        commit("authUser", res.data);
        localStorage.setItem("mitaParsinaSupportToken", res.data.data.token);
        parsinaSupportXios.defaults.headers.common["Authorization"] =
          res.data.data.token;
        router.push({ name: "PPARSINADashboard" });
        EventBus.$emit("user-logged-in");
        setTimeout(() => {
          commit("setSuccess", alert.success.login, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  logout() {
    localStorage.removeItem("mitaParsinaSupportToken");
    parsinaSupportXios.defaults.headers.common["Authorization"] = "";
    router.push({ name: "parsinaSupportLogin" });
  },

  // Upload Actions ------------------------------------------------------------------
  addUpload({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post("filing/api/v1/Upload", data)
      .then((res) => {
        commit("setUploadInfo", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getUploads({ dispatch, commit }, data) {
    parsinaSupportXios
      .get("filing/api/v1/Upload/GetDefaults/" + data)
      .then((res) => {
        commit("setUploads", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUploadsBy({ dispatch }, data) {
    return parsinaSupportXios
      .get("filing/api/v1/Upload/GetDefaults?" + data)
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },

  // DropDown Actions ------------------------------------------------------------------
  getSubSystems({ dispatch, commit }) {
    parsinaSupportXios
      .get("base/api/v1/parsina/DropDown/SubSystems")
      .then((res) => {
        commit("setSubSystems", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getCompanyTypes({ dispatch, commit }) {
    parsinaSupportXios
      .get("base/api/v1/parsina/DropDown/CompanyTypes")
      .then((res) => {
        commit("setCompanyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  // Company Actions ------------------------------------------------------------------
  getCompanies({ dispatch, commit }) {
    parsinaSupportXios
      .get(baseUrl + "parsina/Company")
      .then((res) => {
        commit("setCompanies", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getCompany({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(baseUrl + "parsina/Company/" + data)
      .then((res) => {
        commit("setCompany", res.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  addCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/Company", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .put(baseUrl + "parsina/Company/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .delete(baseUrl + "parsina/Company/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // RelationField Actions ------------------------------------------------------------
  getRelationFields({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setRelationFields", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  upsertRelationField({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/RelationField/Upsert", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  discoverRelationFields({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/RelationField/Discover", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  initializeRelationFields({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .post(baseUrl + "parsina/RelationField/Initialize", {})
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editRelationFieldDeleteBehavior({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .put(
        baseUrl + "parsina/RelationField/UpdateDeleteBehavior/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteRelationFields({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    parsinaSupportXios
      .delete(baseUrl + "parsina/RelationField", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message || alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRelationTables({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/Tables?"+ data)
      .then((res) => {
        commit("setRelationTables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getRelationForeignKeys({ dispatch, commit }) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/ForeignKeys")
      .then((res) => {
        commit("setRelationForeignKeys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  // لیست‌های زیر مخصوص فیلتر جستجو هستند و با انتخاب پایگاه داده والد/فرزند
  // (DbEnumId) و جدول والد (TableName) محدود می‌شوند.
  getRelationParentTables({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/Tables" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setRelationParentTables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getRelationChildTables({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/Tables" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setRelationChildTables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getRelationParentForeignKeys({ dispatch, commit }, data) {
    parsinaSupportXios
      .get(
        baseUrl + "parsina/RelationField/ForeignKeys" + (data ? "?" + data : ""),
      )
      .then((res) => {
        commit("setRelationParentForeignKeys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getDatabases({ dispatch, commit }) {
    parsinaSupportXios
      .get(baseUrl + "parsina/RelationField/DataBases")
      .then((res) => {
        commit("setDatabases", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // Menu Actions ----------------------------------------------------------------------
  // لیست برگردانده می‌شود و صفحه خودش setMenus را می‌زند تا پاسخ دیررسیده‌ی یک
  // زیرسیستم دیگر روی لیست فعلی ننشیند.
  getMenus({ dispatch }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/Menu" + (data ? "?" + data : ""))
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  // فرم ویرایش از همین سرویس پر می‌شود چون PUT همه‌ی فیلدها را می‌خواهد.
  getMenu({ dispatch }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/Menu/" + data)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  editMenu({ dispatch }, data) {
    return parsinaSupportXios
      .put(baseUrl + "parsina/Menu/" + data.id, data.value)
      .then((res) => res.data || {})
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
        return null;
      });
  },

  getClubPermissions({ dispatch, commit }) {
    parsinaSupportXios
      .get(baseUrl + "DropDown/ClubPermissions")
      .then((res) => {
        commit("setClubPermissions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  // Backup Import Actions -------------------------------------------------------------
  getTargetBranches({ dispatch, commit }, data) {
    commit("setTargetBranches", []);
    if (!data) return;
    parsinaSupportXios
      .get(baseUrl + "parsina/DropDown/Branches?companyId=" + data)
      .then((res) => {
        commit("setTargetBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  getSourceBranches({ dispatch, commit }, data) {
    commit("setSourceBranches", []);
    if (!data) return;
    parsinaSupportXios
      .get(baseUrl + "parsina/DropDown/Branches?companyId=" + data)
      .then((res) => {
        commit("setSourceBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      });
  },

  startBackupImport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit("setBackupUploading", true);
    commit("setBackupUploadProgress", 0);
    commit("setBackupImport", null);
    commit("setBackupImportId", null);
    return parsinaSupportXios
      .post(baseUrl + "parsina/BackupImport/Start", data, {
        timeout: 0,
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
        onUploadProgress: (event) => {
          if (event.total) {
            commit(
              "setBackupUploadProgress",
              Math.round((event.loaded * 100) / event.total),
            );
          }
        },
      })
      .then((res) => {
        const started = (res.data && res.data.data) || {};
        commit("setBackupImportId", started.importId);
        commit("setBackupImport", {
          id: started.importId,
          status: 0,
          currentStep: null,
          error: null,
          fiscalYearMaps: [],
          modules: [],
          log: [],
        });
        return started.importId;
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerSupport", error, { root: true });
      })
      .finally(() => {
        commit("setBackupUploading", false);
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBackupImportStatus({ commit }, data) {
    return parsinaSupportXios
      .get(baseUrl + "parsina/BackupImport/Status/" + data)
      .then((res) => {
        commit("setBackupImport", res.data.data);
        return res.data.data;
      });
  },

  // Backup Export Actions -------------------------------------------------------------
  downloadFullBackup({ commit }) {
    commit("setBackupExporting", true);
    commit("setLoadingBtn", true, { root: true });
    return parsinaSupportXios
      .get(baseUrl + "parsina/BackupExport/Download", {
        responseType: "blob",
        timeout: 0,
        maxContentLength: Infinity,
      })
      .then((res) => {
        const disposition = res.headers["content-disposition"] || "";
        const matched = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(
          disposition,
        );
        const fileName = matched
          ? decodeURIComponent(matched[1].trim())
          : "Mita-backup.zip";
        const blob = new Blob([res.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        // بدنه‌ی خطا هم blob است، پس پیام سرور باید از متن آن خوانده شود.
        const body = error.response && error.response.data;
        if (body instanceof Blob) {
          return body
            .text()
            .then((text) => {
              let message = "";
              try {
                message = JSON.parse(text).message;
              } catch (e) {
                message = "";
              }
              commit("setError", message || alert.error.server, { root: true });
            })
            .catch(() => {
              commit("setError", alert.error.server, { root: true });
            });
        }
        commit(
          "setError",
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
            alert.error.server,
          { root: true },
        );
      })
      .finally(() => {
        commit("setBackupExporting", false);
        commit("setLoadingBtn", false, { root: true });
      });
  },
};
